import { render } from "./blog.vue?vue&type=template&id=327739b8"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__